export const ConfigurationIAExcludedUrlsLoading = [
  'norespuesta/asistente-configuracion/delete',
  'norespuesta/asistente-configuracion/add',
];